export const figure18b = {
  chart: {
      type: 'line',
      backgroundColor: 'rgba(255, 255, 255, 0.0)',
        height: 230,
      plotBackgroundColor: null,
      plotBorderWidth: null,
    },
    credits: {
      enabled: false
  },
    title: {
      text: 'Paraguay'
    },
    subtitle: {
      text: null
  },
    xAxis: {
      categories: ['2015','2016','2017', '2018', '2019', '2020',]
    },
    labels: {
      	
      style: {
        fontWeight: 'normal',
        color: '#999999',
        fontSize: '12px'
      },
    },
    yAxis: {
      min: 0,
      max: 4000,
      tickInterval: 1000,
      title: {
          text: null,
      },
    },
    plotOptions: {
      line: {
        dataLabels: {
          enabled: false
        },
        enableMouseTracking: true
      }
    },
    legend: {
      enabled: false,
  },
    colors: ['#5b9bd5', '#ed7d32','#cbcccb', '#ffc100'],
    series: [{
      name: 'Petites exploitations',
      data: [2653, 2795, 3087, 3384, 2655, 2118,]
    }, 
  ]
  }

  